export const SliderData = [
    {
        image: 'https://image-slider-react.s3.amazonaws.com/waterfalls/waterfall1.png'
    },
    {
        image: 'https://image-slider-react.s3.amazonaws.com/waterfalls/waterfall2.png'
    },
    {
        image: 'https://image-slider-react.s3.amazonaws.com/waterfalls/waterfall3.png'
    },
    {
        image: 'https://image-slider-react.s3.amazonaws.com/waterfalls/waterfall4.png'
    },
    {
        image: 'https://image-slider-react.s3.amazonaws.com/waterfalls/waterfall5.png'
    },
    {
        image: 'https://image-slider-react.s3.amazonaws.com/waterfalls/waterfall6.png'
    },
    {
        image: 'https://image-slider-react.s3.amazonaws.com/waterfalls/waterfall7.png'
    },
    {
        image: 'https://image-slider-react.s3.amazonaws.com/waterfalls/waterfall8.png'
    },
    {
        image: 'https://image-slider-react.s3.amazonaws.com/waterfalls/waterfall9.png'
    }
]
